define('responsive-game-feed/app/scripts/models/PItchModel',['require','exports','module'],function(require, exports, module) {

	function PitchModel($pitchVO) {

	    var _self = this;
	    this._thePitchVO;
	
	    //Strings
	    this.des = (function() {
	        var val = (typeof $pitchVO.des === "string") ? $pitchVO.des : "";
	        return val;
	    }());
	
	    this.id = $pitchVO.id;
	    this.type = $pitchVO.type;
	    this.pitch_type = $pitchVO.pitch_type;
	
	    this.tfs_zulu = $pitchVO.tfs_zulu;
	    this.tfs = $pitchVO.tfs;
	
	    this.color_commentary = $pitchVO.cc;
	    this.name = (function() {
	        if ($pitchVO.name == "p") {
	            return "pitch";
	        } else {
	            return $pitchVO.name;
	        }
	    }());
	    this.hasPfxData = (!isNaN($pitchVO.start_speed));
	    //Numbers
	    this.x = parseFloat($pitchVO.x);
	    this.y = parseFloat($pitchVO.y);
	    this.start_speed = parseFloat($pitchVO.start_speed);
	    this.end_speed = parseFloat($pitchVO.end_speed);
	    this.sz_top = parseFloat($pitchVO.sz_top);
	    this.sz_bot = parseFloat($pitchVO.sz_bot);
	    this.pfx_x = parseFloat($pitchVO.pfx_x);
	    this.pfx_z = parseFloat($pitchVO.pfx_z);
	    this.px = parseFloat($pitchVO.px);
	    this.pz = parseFloat($pitchVO.pz);
	    this.x0 = parseFloat($pitchVO.x0);
	    this.y0 = parseFloat($pitchVO.y0);
	    this.z0 = parseFloat($pitchVO.z0);
	    this.vx0 = parseFloat($pitchVO.vx0);
	    this.vy0 = parseFloat($pitchVO.vy0);
	    this.vz0 = parseFloat($pitchVO.vz0);
	    this.ax = parseFloat($pitchVO.ax);
	    this.ay = parseFloat($pitchVO.ay);
	    this.az = parseFloat($pitchVO.az);
	    this.break_x = parseFloat($pitchVO.break_x);
	    this.break_y = parseFloat($pitchVO.break_y);
	    this.break_z = parseFloat($pitchVO.break_z);
	    this.break_angle = ( !! this.hasPfxData) ? parseFloat($pitchVO.break_angle) : "";
	    this.break_length = ( !! this.hasPfxData) ? parseFloat($pitchVO.break_length) + "\"" : "";
	    this.nasty = ( !! this.hasPfxData && !isNaN($pitchVO.nasty)) ? parseFloat($pitchVO.nasty) : "";
	    this.sv_id = String($pitchVO.sv_id);
	    this.idx = parseInt($pitchVO.idx);
	}
	
	PitchModel.prototype = {
	
	
	    is_pitch: function() {
	        return (this.name == "pitch" || this.name == "p");
	    },
	
	    getPfxString: function($addTrailingDecimal) {
	        if (!this.hasPfxData)
	            return "";
	        if (this.sv_id.toString().length > 0) {
	            var pfx_val = Math.sqrt((this.pfx_x * this.pfx_x) + (this.pfx_z * this.pfx_z));
	
	            if (!isNaN(pfx_val)) {
	                var pfx_str = ($addTrailingDecimal === true) ? formatDecimal(pfx_val) : Math.round(pfx_val).toString();
	                return pfx_str + "\"";
	            };
	        };
	        return "";
	
	        function formatDecimal(num) {
	            if (isNaN(num)) return "--";
	            else return Math.floor(num) + "." + Math.abs(Math.round((Math.floor(num) - num) * 10));
	        }
	
	    }
	}
	return PitchModel;
});
